import service from '@/store/services/vendors/labourer-parents-service';

const state = {
    list: {},
    labourerParent: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, labourerParent) => {
        state.labourerParent = labourerParent;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(labourerParent => {
                commit('SET_RESOURCE', labourerParent);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(labourerParent => {
                commit('SET_RESOURCE', labourerParent);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((labourerParent) => {
                commit('SET_RESOURCE', labourerParent);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((labourerParent) => {
                commit('SET_RESOURCE', labourerParent);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    labourerParent: state => state.labourerParent,
    dropdown: (state) => {
        return state.list.map(labourerParent => ({
            id: labourerParent.id,
        }));
    }
};

const labourerParents = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default labourerParents;
